// extracted by mini-css-extract-plugin
export default {"Header":"header_Header__D+UKB","floatRight":"header_floatRight__NLpDx"};